var Logman = function Logman(type) {
  if (!window) {
    throw Error("Logman is meant to work in browsers. No `window` or `window.console` object found");
  }

  this.type = type;
  this.isSleep = false;
  this.isDestroyed = false;
};

Logman.prototype._act = function _act(action, messages) {
  window.console[action].apply(this, ["[" + this.type + "]"].concat([].slice.call(messages)));
};

Logman.prototype._isActive = function _isActive() {
  try {
    return process && process.env && process.env.NODE_ENV !== "production" && !this.isSleep && !this.isDestroyed;
  } catch (err) {
    return false;
  }
};

Logman.prototype.log = function log() {
  this._isActive() && this._act.bind(this, "log")(arguments);
};

Logman.prototype.error = function error() {
  !this._isActive() && this._act.bind(this, "error")(arguments);
};

Logman.prototype.sleep = function sleep() {
  this.isSleep = true;
};

Logman.prototype.awake = function awake() {
  this.isSleep = false;
};

Logman.prototype.destroy = function destroy() {
  this.isDestroyed = true;
};

module.exports = Logman;